import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// hooks
import {useBoolean} from '../hooks/use-boolean';
import {useResponsive} from '../hooks/use-responsive';
// components
import {useSettingsContext} from '../components/settings';
//
import Main from './main';
import Header from './header';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';

// ----------------------------------------------------------------------

export default function DashboardLayout({children}) {
    const settings = useSettingsContext();

    const lgUp = useResponsive('up', 'lg');

    const nav = useBoolean();


    const isMini = settings.themeLayout === 'mini';

    const renderNavMini = <NavMini/>;

    const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} 
                                           files={settings.files} valid={settings.valid} />;
    if (isMini) {
        return (
            <>
                <Header onOpenNav={nav.onTrue}/>

                <Box
                    sx={{
                        minHeight: 1,
                        display: 'flex',
                        flexDirection: {xs: 'column', lg: 'row'},
                    }}
                >
                    {lgUp ? renderNavMini : renderNavVertical}

                    <Main>{children}</Main>
                </Box>
                
            </>
        );
    }

    return (
        <>
            <Header onOpenNav={nav.onTrue}/>

            <Box
                sx={{
                    minHeight: 1,
                    display: 'flex',
                    flexDirection: {xs: 'column', lg: 'row'},
                }}
            >
                {renderNavVertical}

                <Main
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '107vh', // ocupa toda la pantalla
                    }}
                    >
                    {/* contenido que crece */}
                    <Box sx={{ flexGrow: 1 }}>
                        {children}
                    </Box>
                </Main>
            </Box>
        </>
    );
}

DashboardLayout.propTypes = {
    children: PropTypes.node,
};
